import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const AdminRoute = ({ component: RouteComponent, ...rest }) => {
  const { currentUser, isAdmin } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={routeProps =>
        currentUser && isAdmin() ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};

export default AdminRoute;
